import { render } from "./TechSupportPage.vue?vue&type=template&id=60e1fc78&scoped=true"
import script from "./TechSupportPage.vue?vue&type=script&lang=js"
export * from "./TechSupportPage.vue?vue&type=script&lang=js"

import "./TechSupportPage.vue?vue&type=style&index=0&id=60e1fc78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e1fc78"]])

export default __exports__